import { render, staticRenderFns } from "./OBtn.vue?vue&type=template&id=4ae0e3db"
import script from "./OBtn.vue?vue&type=script&lang=ts"
export * from "./OBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports